<div class="w-full max-w-full overflow-x-hidden">
  <app-navbar></app-navbar>
  <router-outlet></router-outlet>
</div>